type Colors = {
  deal: {
    backgroundGradient: string;
    priceColor: string;
  };
};

export const colors: Colors = {
  deal: {
    backgroundGradient:
      'linear-gradient(90deg, #F9700C 38.49%, #DA3835 96.35%)',
    priceColor: 'red.50',
  },
};
